import React from "react";
// import Header from "../Header/Header.jsx";
import Main from "../Main/Main";

const Home = () => {
  return <Main />;
};

export default Home;
